import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ExcluirParametroLocalidade } from './types';

export const INITIAL_STATE: ExcluirParametroLocalidade = {
	status: 0,
	data: null,
};

export default function excluirParametroLocalidadeReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirParametroLocalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_PARAMETRO_LOCALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_LOCALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_LOCALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_PARAMETRO_LOCALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
